import { render, staticRenderFns } from "./ProjectProductCardList.vue?vue&type=template&id=42ac32a1"
import script from "./ProjectProductCardList.vue?vue&type=script&lang=js"
export * from "./ProjectProductCardList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports